export default __webpack_public_path__ + "static/media/billy_secure.44f78f44.png";